import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { FullPageLoader } from '@/components/ui/loading-spinner'
import { useExperienceLabAccess } from '@/hooks/useExperienceLabAccess'
import type { ExperienceLabRouteProps } from './ExperienceLabRoute.types'

export function ExperienceLabRoute({
  children,
}: ExperienceLabRouteProps): ReactElement {
  const { allowed, isLoading } = useExperienceLabAccess()

  if (isLoading) {
    return <FullPageLoader message="Checking Experience Lab access…" />
  }

  if (!allowed) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
